import React, { useEffect, useState } from 'react';
import { useCustomerApi } from '../../../customers/hooks/customerApi';
import { MobileVerifyResponseType } from '../../../customers/hooks/useMobileVerify';
import { pageThemeEnum } from '../../../customers/hooks/useVerifyLayout/helpers';
import { useVerifyLayout } from '../../../customers/hooks/useVerifyLayout/useVerifyLayout';
import LinkReceiptsView from '../../../customers/components/phoneVerify/setMobile/LinkReceipts';
import { AddMobileAndBirthday } from './AddMobileAndBirthday';
import Landing from '../../../customers/components/phoneVerify/Landing';

enum PromptType {
  AddMobileAndBirthday = 'AddMobileAndBirthday',
  LinkReceiptsView = 'LinkReceiptsView',
}

export const HandleMobilePrompt = ({
  onVerifyMobileResponse,
}: {
  onVerifyMobileResponse: (data: MobileVerifyResponseType) => void;
}): JSX.Element => {
  const { pageTheme } = useVerifyLayout();
  const { customer, loading: customerLoading } = useCustomerApi();
  const [pageComponent, setPageComponent] = useState<PromptType>();

  useEffect(() => {
    if (customerLoading || Boolean(pageComponent)) return;
    if (pageTheme.current === pageThemeEnum.perks && !customer?.birthMonth) {
      setPageComponent(PromptType.AddMobileAndBirthday);
    } else {
      setPageComponent(PromptType.LinkReceiptsView);
    }
  }, [customerLoading]);

  if (pageComponent === PromptType.AddMobileAndBirthday) {
    return <AddMobileAndBirthday handleRedirect={onVerifyMobileResponse} heading="Nearly done ..." />;
  } else if (pageComponent === PromptType.LinkReceiptsView) {
    return <LinkReceiptsView handleRedirect={onVerifyMobileResponse} />;
  } else {
    return <Landing handleRedirect={onVerifyMobileResponse} />;
  }
};
